// Copyright (c) Zammo Inc.

import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '@iconify/react';
import settingsIcon from '@iconify/icons-simple-line-icons/settings';
import speechIcon from '@iconify/icons-simple-line-icons/speech';

import { ReactComponent as CaptionIcon } from '../../assets/icon-caption.svg';
import { palette } from '../../styles/variables';
import { Voice } from '../../app/actions';

import VoiceSettingModal from './VoiceSettingModal';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type ButtonProps = {
  active: boolean;
};
const Button = styled.button<ButtonProps>`
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 2rem;
  color: ${(props) => (props.active ? palette.blue : palette.pink)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: ${(props) => (props.active ? palette.blue : palette.pink)};
  }
`;

type Props = {
  isCaptionActive: boolean;
  isChatActive: boolean;
  selectedVoice: string;
  allVoices: Voice[];

  toggleCaption: () => void;
  toggleChat: () => void;
  setSelectedVoice: (voiceName: string) => void;
};
function VoiceSimulatorControl({
  isCaptionActive,
  isChatActive,
  selectedVoice,
  allVoices,
  toggleCaption,
  toggleChat,
  setSelectedVoice,
}: Props) {
  const [showSettingModal, setShowSettingModal] = useState(false);
  return (
    <>
      <Container>
        <Button onClick={toggleCaption} active={isCaptionActive}>
          <CaptionIcon />
        </Button>
        <Button active={true} onClick={() => setShowSettingModal(true)}>
          <Icon icon={settingsIcon} />
        </Button>
        <Button onClick={toggleChat} active={isChatActive}>
          <Icon icon={speechIcon} />
        </Button>
      </Container>
      <VoiceSettingModal
        isOpen={showSettingModal}
        selectedVoice={selectedVoice}
        allVoices={allVoices}
        setSelectedVoice={setSelectedVoice}
        onClose={() => setShowSettingModal(false)}
      />
    </>
  );
}

export default VoiceSimulatorControl;
